module.exports = __webpack_public_path__ + "static/media/Colette Ray King Headboard - 180 cm_Blush Pink.ba4787ec.png";